module.exports = __webpack_public_path__ + "t.no2.e92386fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/t.no2.jpg
// module id = C+z7
// module chunks = 0